<div class="bg-[#134F82] py-2 px-3 flex items-center justify-between w-full">
  <!-- Icono izquierdo (usuario) -->
<button class="flex items-center justify-center w-9 h-9 rounded-full bg-[#134F82] text-white">
  <mat-icon fontIcon="person" class="text-sm"></mat-icon>
</button>

<!-- Icono derecho (cerrar) -->
<button class="flex items-center justify-center w-9 h-9 rounded-full bg-[#134F82] border border-1 text-white" (click)="goToHome()">
  <mat-icon fontIcon="close" class="flex items-center justify-center"></mat-icon>
</button>
</div>